<template>
  <div>
    <hero title="Desenvolvedor e Analista" description="Formado na Faculdade de Informática de Presidente Prudente - Unoeste"></hero>

    <!-- documentacao -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="require('@/assets/images/documentos.jpg')"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Documentação
                </h4>
                <p class="lead text-italic text-white">
                  Todos os projetos possuem suas devidas documentações.
                  Denominada de engenharia de requisitos (ERS), visa documentar
                  o escopo, lista de funções, a viabilidade do sistema, dentre
                  outras diversas funções.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                name="ni ni-settings"
                class="mb-5"
                size="lg"
                type="warning"
                shadow
                rounded
              ></icon>

              <h3>Projetos</h3>
              <p class="lead">
                Cada projeto deve ter sua própria ERS, levando em consideração
                que cada projeto é único.
              </p>
              <p>
                A ERS serve tanto para o cliente quanto para o desenvolvedor, de
                maneira que ela deve sempre conter o contexto do sistema.
              </p>
              <p>
                A partir das telas de protótipo da ERS fica bem mais simples
                visualizar o produto que será gerado. Uma vez a ERS criada,
                pode-se dar início ao desenvolvimento do sistema.
              </p>
              <span class="font-weight-bold text-warning mt-5"
                >Sites e sistemas bonitos e bem construídos prendem o
                usuário</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- projeto 1 -->
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-2 bg-gradient-blue shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img
              src="@/assets/images/quickblue.png"
              class="img-fluid floating"
            />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5 text-white"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3 class="text-white">Projeto do meu estágio</h3>
              <p class="text-white">
                Este projeto foi desenvolvido por mim para uma empresa que
                realiza prestação de serviço mediante contrato com o cliente.
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-th"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Cadastro de clientes e contratos
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-usd"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Controle de receitas e despesas
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-phone"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Controle de atendimentos aos clientes
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file-o"
                    ></badge>
                    <h6 class="mb-0 text-white">Emissão de NFS-e</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section my-0">
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="@/assets/images/nfse.png" class="img-fluid floating" />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="fa fa-file-o"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3 class="">Emissão NFS-e</h3>
              <p class="">
                O projeto conta com uma API dedicada para emissão de Notas
                Fiscais de Serviço Eletrônicas na prefeitura de Presidente
                Prudente. Você pode checar o projeto no meu GitHub!
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file"
                    ></badge>
                    <h6 class="mb-0">Gerar Notas Fiscais</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-usd"
                    ></badge>
                    <h6 class="mb-0">Consultar Nota fiscal</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file-pdf-o"
                    ></badge>
                    <h6 class="mb-0">Emitir PDF da nota</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-envelope"
                    ></badge>
                    <h6 class="mb-0">Enviar NFSe por email</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <a
            href="https://github.com/makinado?tab=repositories"
            target="_blank"
          >
            <h2 class="text-success mt-5">
              Veja o projeto no meu GitHub clicando aqui
            </h2>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Hero from "./components/Hero";
// import BasicElements from "./components/BasicElements";
// import Inputs from "./components/Inputs";
// import CustomControls from "./components/CustomControls";
// import Navigation from "./components/Navigation";
// import JavascriptComponents from "./components/JavascriptComponents";
// import Carousel from "./components/Carousel";
// import Icons from "./components/Icons";
// import Examples from "./components/Examples";
// import DownloadSection from "./components/DownloadSection";

export default {
  name: "components",
  components: {
    Hero,
    // BasicElements,
    // Inputs,
    // CustomControls,
    // Navigation,
    // JavascriptComponents,
    // Carousel,
    // Icons,
    // Examples,
    // DownloadSection,
  },
};
</script>
